import React from "react";

export default function CommercialIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="2"
        y="7"
        width="20"
        height="15"
        rx="1"
        stroke="#14508c"
        strokeWidth="1.5"
        fill="none"
      ></rect>
      <path
        d="M6 7V4a1 1 0 011-1h10a1 1 0 011 1v3"
        stroke="#14508c"
        strokeWidth="1.5"
        fill="none"
      ></path>
      <rect
        x="9"
        y="13"
        width="3"
        height="4"
        rx=".5"
        stroke="#14508c"
        strokeWidth="1.2"
        fill="none"
      ></rect>
      <rect
        x="13"
        y="13"
        width="3"
        height="4"
        rx=".5"
        stroke="#14508c"
        strokeWidth="1.2"
        fill="none"
      ></rect>
    </svg>
  );
}
